/** @format */

import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { Layout, Form, Col, Row, Typography } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';

import InputField from '../../../components/Input';
import Button from '../../../components/Button';
import Images from '../../../components/Images';
import Spacer from '../../../components/Spacer';
import AuthSideBox from '../../../components/AuthSideBox';
import { Service } from './service';
import { LOCAL_STORAGE } from '../../../v2-config/constants/local-storage.constant';
import { CustomNotification } from '../../../v2-components/Notification';
import useNotificationStore from '../../notification/store/useNotificationStore';
import './style.css';

export default function LoginV2(props) {
	const [loading, setLoading] = useState(false);
	const setToken = useNotificationStore((state) => state.setToken);

	const handleSubmitLogin = (item) => {
		setLoading(true);
		new Service()
			.login(item)
			.then((response) => {
				console.log('response', response);
				if (response.token) {
					setToken(response?.token);
					setLoading(false);
					localStorage.setItem(LOCAL_STORAGE.LOG, true);
					localStorage.setItem(LOCAL_STORAGE.USER, JSON.stringify(response));
					CustomNotification({
						type: 'success',
						message: 'Bienvenido al panel',
						description: 'Recuerde que los permisos del panel dependen de su usuario',
					});
					props.history.push('/');
				} else {
					setLoading(false);
					return CustomNotification({
						type: 'error',
						message: 'Error',
						description: response.message,
					});
				}
			})
			.catch((error) => {
				console.log('[ERROR]', error);
				CustomNotification({ type: 'error', message: 'Error en el servicio', description: 'Comuniquese con soporte para más detalles' });
			});
	};

	return (
		<div className="ph-login-page-container">
			<Layout>
				<div className="ph-login-responsive-logo-container">
					<Images
						default={`${process.env.REACT_APP_GENERAL_STORAGE_IMAGES}/panel-admin/${process.env.REACT_APP___COUNTRY}/logo.png`}
						title={`Logo Inicio`}
					/>
					<Typography.Text className="ph-login-responsive-title">Panel de Administración</Typography.Text>
				</div>
				<Layout.Content className="ph-login-main-container ph-login-page">
					<Row className="ph-login-inner-container">
						<Col span={24}>
							<Row>
								<Col xs={24} sm={10} md={9} lg={9} xl={8} className="ph-login-authside-container">
									<AuthSideBox />
								</Col>
								<Col xs={24} sm={14} md={15} lg={15} xl={16}>
									<div className="ph-login-main-form-container">
										<Row className="ph-login-main-form-inner-container">
											<Col span={24}>
												<h2 className="ph-login-main-form-title">Acceso</h2>
												<h3 className="ph-login-main-form-description">Ingresa tus credenciales de acceso...</h3>{' '}
												<Form
													className="ph-login-form-content"
													name="normal_login"
													initialValues={{ remember: true }}
													onFinish={handleSubmitLogin}
												>
													<InputField
														inputName={'email'}
														inputNameLabel={'Correo electrónico'}
														inputNameRule={true}
														inputNameMessage={'Ingresa tu correo'}
														inputNameType={'text'}
														inputNameIcon={<MailOutlined />}
														inputNameRules={'rulesEmail'}
													/>
													<div className="ph-login-password-field-container">
														<Link to="/recover">
															<h3 className="ph-login-password-field-title">¿Olvidó su contraseña?</h3>
														</Link>
														<InputField
															inputName={'password'}
															inputNameLabel={'Contraseña'}
															inputNameRule={true}
															inputNameMessage={'Ingresa tu contraseña'}
															inputNameType={'password'}
															inputNameIcon={<LockOutlined />}
															inputNameRules={'rulesPassword'}
														/>
													</div>
													<Form.Item>
														<div className="ph-login-button-container">
															<h3 className="ph-login-button-register-description">
																¿No tienes cuenta?
																<Link to="/register">
																	<span className="ph-login-button-register-description-inner">Regístrate</span>
																</Link>
															</h3>
															<Spacer />
															<Button labelName={'Ingresar'} loadingSubmit={loading} />
														</div>
													</Form.Item>
												</Form>
											</Col>
										</Row>
									</div>
								</Col>
							</Row>
						</Col>
					</Row>
				</Layout.Content>
			</Layout>
		</div>
	);
}
